import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { hanscribeRoleLabel } from "src/libs/portal/hanscribe/hanscribe";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
  background: #f6f8f7;
}

.account-page {
  --account-bg: #f6f8f7;
  --account-surface: #fffefa;
  --account-surface-soft: #f7f7f3;
  --account-ink: #1d2622;
  --account-body: #46504b;
  --account-muted: #5f6964;
  --account-border: #dedfd8;
  --account-border-strong: #cdd2cc;
  --account-primary: #17483e;
  --account-primary-hover: #215e51;
  --account-primary-soft: #e8f1ed;
  --account-focus: rgba(23, 72, 62, 0.2);
  --account-font-page-title: 26px;
  --account-font-section-title: 17px;
  --account-font-body: 14px;
  --account-font-secondary: 13px;
  --account-font-caption: 12px;
  min-height: 100%;
  background: var(--account-bg);
  color: var(--account-ink);
  font-family: "SUIT", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: var(--account-font-body);
  font-weight: 400;
  line-height: 1.5;
}

.account-page,
.account-page * {
  box-sizing: border-box;
  font-family: inherit;
}

.account-shell {
  width: min(100%, 1320px);
  margin: 0 auto;
  padding: 26px 28px 44px;
}

.account-page-header {
  display: flex;
  min-height: 66px;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
}

.account-page-heading {
  min-width: 0;
}

.account-page-heading h1 {
  margin: 0;
  font-size: var(--account-font-page-title);
  line-height: 34px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.account-page-heading p {
  margin: 3px 0 0;
  color: var(--account-muted);
  font-size: var(--account-font-body);
  line-height: 21px;
}

.account-create-button,
.account-button,
.account-search-submit {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9px;
  cursor: pointer;
  font-size: var(--account-font-body);
  font-weight: 600;
}

.account-create-button {
  flex: 0 0 auto;
  gap: 7px;
  background: var(--account-primary);
  padding: 0 16px;
  color: #ffffff;
}

.account-create-button svg {
  width: 17px;
  height: 17px;
}

.account-create-button:hover:not(:disabled),
.account-button--primary:hover:not(:disabled),
.account-search-submit:hover:not(:disabled) {
  background: var(--account-primary-hover);
}

.account-alert {
  margin-bottom: 12px;
  border: 1px solid;
  border-radius: 9px;
  padding: 11px 14px;
  font-size: var(--account-font-body);
  line-height: 19px;
  font-weight: 600;
}

.account-alert--error {
  border-color: #e6c7c2;
  background: #fff6f4;
  color: #92483f;
}

.account-alert--success {
  border-color: #c5ddd4;
  background: #f0f8f4;
  color: #236251;
}

.recovery-panel {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e1cfaa;
  border-radius: 11px;
  background: #fffaf0;
}

.recovery-panel-header,
.recovery-row {
  display: flex;
  align-items: center;
}

.recovery-panel-header {
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #eadbbd;
  padding: 13px 16px;
}

.recovery-panel-header h2,
.account-list-header h2,
.role-guide h2 {
  margin: 0;
  font-size: var(--account-font-section-title);
  line-height: 24px;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.recovery-panel-header p,
.account-list-header p,
.role-guide header p {
  margin: 2px 0 0;
  color: var(--account-muted);
  font-size: var(--account-font-secondary);
  line-height: 19px;
}

.recovery-count {
  display: inline-flex;
  min-width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ead6aa;
  color: #765217;
  font-size: var(--account-font-secondary);
  font-weight: 700;
}

.recovery-row {
  min-height: 64px;
  gap: 16px;
  padding: 10px 16px;
}

.recovery-row + .recovery-row {
  border-top: 1px solid #eee1c7;
}

.recovery-account {
  min-width: 0;
  flex: 1 1 auto;
}

.recovery-account strong,
.recovery-account span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recovery-account strong {
  font-size: var(--account-font-body);
  line-height: 20px;
  font-weight: 600;
}

.recovery-account span,
.recovery-requested {
  color: #766b57;
  font-size: var(--account-font-secondary);
  line-height: 19px;
}

.recovery-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.recovery-actions .account-button {
  min-height: 36px;
  padding: 0 11px;
}

.account-toolbar {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
  border: 1px solid var(--account-border);
  border-radius: 11px;
  background: var(--account-surface);
  padding: 10px 12px;
}

.role-filters {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
}

.role-filters button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 0 11px;
  color: var(--account-body);
  cursor: pointer;
  font-size: var(--account-font-body);
  font-weight: 600;
  white-space: nowrap;
}

.role-filters button strong {
  color: var(--account-muted);
  font-size: var(--account-font-secondary);
  font-weight: 600;
}

.role-filters button:hover {
  background: var(--account-surface-soft);
}

.role-filters button.is-active {
  border-color: #bfd0c9;
  background: var(--account-primary-soft);
  color: var(--account-primary);
}

.role-filters button.is-active strong {
  color: inherit;
}

.account-search {
  position: relative;
  display: flex;
  width: min(390px, 100%);
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}

.account-search-field {
  position: relative;
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
}

.account-search-field svg {
  position: absolute;
  left: 11px;
  width: 17px;
  height: 17px;
  color: #87908b;
  pointer-events: none;
}

.account-search-field input {
  width: 100%;
  height: 40px;
  border: 1px solid var(--account-border-strong);
  border-radius: 8px;
  background: #ffffff;
  padding: 0 35px 0 36px;
  color: var(--account-ink);
  font-size: var(--account-font-body);
  outline: none;
}

.account-search-clear {
  position: absolute;
  right: 76px;
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--account-muted);
  cursor: pointer;
}

.account-search-clear svg {
  width: 15px;
  height: 15px;
}

.account-search-submit {
  min-width: 68px;
  min-height: 40px;
  background: var(--account-primary);
  color: #ffffff;
}

.account-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 286px;
  align-items: start;
  gap: 14px;
}

.account-list-panel,
.role-guide {
  overflow: hidden;
  border: 1px solid var(--account-border);
  border-radius: 11px;
  background: var(--account-surface);
}

.account-list-header {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--account-border);
  padding: 13px 16px;
}

.account-list-header > strong {
  flex: 0 0 auto;
  color: var(--account-primary);
  font-size: var(--account-font-body);
  font-weight: 700;
}

.account-loading,
.account-empty {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  color: var(--account-muted);
}

.account-loading {
  gap: 9px;
  font-size: var(--account-font-body);
  font-weight: 600;
}

.account-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #d9e1dd;
  border-top-color: var(--account-primary);
  border-radius: 50%;
  animation: account-spin 700ms linear infinite;
}

.account-empty {
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.account-empty strong {
  color: var(--account-body);
  font-size: 15px;
  font-weight: 600;
}

.account-empty p {
  margin: 0;
  font-size: var(--account-font-secondary);
}

.account-table-head,
.account-row {
  display: grid;
  grid-template-columns: minmax(230px, 1.35fr) 120px minmax(150px, 0.85fr) 90px 44px;
  align-items: center;
  gap: 12px;
}

.account-table-head {
  min-height: 36px;
  border-bottom: 1px solid var(--account-border);
  background: var(--account-surface-soft);
  padding: 7px 14px;
  color: var(--account-muted);
  font-size: var(--account-font-caption);
  line-height: 16px;
  font-weight: 600;
}

.account-row {
  min-height: 72px;
  padding: 10px 14px;
}

.account-row + .account-row {
  border-top: 1px solid #e9eae5;
}

.account-row:hover {
  background: #fbfcf9;
}

.account-person {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.account-avatar {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #e7eee9;
  color: var(--account-primary);
  font-size: var(--account-font-body);
  font-weight: 700;
}

.account-person > div {
  min-width: 0;
}

.account-name-line {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.account-name-line strong,
.account-email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-name-line strong {
  color: var(--account-ink);
  font-size: var(--account-font-body);
  line-height: 20px;
  font-weight: 700;
}

.account-name-line em {
  display: inline-flex;
  min-height: 20px;
  flex: 0 0 auto;
  align-items: center;
  border-radius: 999px;
  background: var(--account-primary-soft);
  padding: 1px 7px;
  color: var(--account-primary);
  font-size: var(--account-font-caption);
  font-style: normal;
  font-weight: 600;
}

.account-email {
  display: block;
  margin-top: 1px;
  color: var(--account-muted);
  font-size: var(--account-font-secondary);
  line-height: 19px;
}

.account-role-display {
  display: flex;
  min-width: 0;
  align-items: center;
}

.account-scope,
.account-joined {
  color: #59635e;
  font-size: var(--account-font-secondary);
  line-height: 19px;
  font-weight: 400;
}

.account-joined {
  color: var(--account-muted);
  white-space: nowrap;
}

.account-row-actions {
  display: flex;
  justify-content: flex-end;
}

.account-remove-button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  padding: 0;
  color: #7b8580;
  cursor: pointer;
}

.account-remove-button svg {
  width: 18px;
  height: 18px;
}

.account-remove-button:hover:not(:disabled) {
  background: #f8eeec;
  color: #8c433a;
}

.account-protected {
  color: var(--account-muted);
  font-size: var(--account-font-caption);
  font-weight: 500;
}

.role-guide {
  position: sticky;
  top: 18px;
}

.role-guide > header {
  border-bottom: 1px solid var(--account-border);
  padding: 14px 15px;
}

.role-guide-list article {
  padding: 14px 15px;
}

.role-guide-list article + article {
  border-top: 1px solid #e9eae5;
}

.role-guide-list article > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.role-guide-list article > div strong {
  color: var(--account-body);
  font-size: var(--account-font-secondary);
  line-height: 18px;
  font-weight: 600;
}

.role-guide-list article p {
  margin: 7px 0 0;
  color: var(--account-muted);
  font-size: var(--account-font-secondary);
  line-height: 20px;
}

.account-role-text {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
  color: var(--account-body);
  font-size: var(--account-font-secondary);
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
}

.account-role-text--unknown {
  color: #66706b;
}

.account-modal-backdrop {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(27, 35, 31, 0.42);
  backdrop-filter: blur(2px);
}

.account-create-modal {
  width: min(620px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  border: 1px solid rgba(52, 64, 57, 0.15);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(21, 29, 24, 0.24);
}

.account-create-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--account-border);
  padding: 20px 22px 17px;
}

.account-create-header h2 {
  margin: 1px 0 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.account-create-header p {
  margin: 3px 0 0;
  color: var(--account-muted);
  font-size: var(--account-font-secondary);
  line-height: 19px;
}

.account-modal-close {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: var(--account-muted);
  cursor: pointer;
}

.account-modal-close svg {
  width: 20px;
  height: 20px;
}

.account-modal-close:hover:not(:disabled) {
  border-color: var(--account-border);
  background: var(--account-surface-soft);
  color: var(--account-ink);
}

.account-create-form {
  display: grid;
  gap: 22px;
  padding: 20px 22px 22px;
}

.account-create-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px;
}

.account-field {
  display: grid;
  min-width: 0;
  gap: 6px;
}

.account-field--wide {
  grid-column: 1/-1;
}

.account-field > span,
.account-role-selector legend {
  color: var(--account-body);
  font-size: var(--account-font-body);
  line-height: 18px;
  font-weight: 600;
}

.account-field input {
  width: 100%;
  height: 43px;
  border: 1px solid var(--account-border-strong);
  border-radius: 8px;
  background: #ffffff;
  padding: 0 12px;
  color: var(--account-ink);
  font-size: var(--account-font-body);
  outline: none;
}

.account-field small {
  color: var(--account-muted);
  font-size: var(--account-font-caption);
  line-height: 17px;
}

.account-password-field {
  position: relative;
}

.account-password-field input {
  padding-right: 62px;
}

.account-password-field button {
  position: absolute;
  top: 5px;
  right: 5px;
  min-width: 50px;
  height: 33px;
  border: 0;
  border-radius: 6px;
  background: var(--account-surface-soft);
  color: var(--account-body);
  cursor: pointer;
  font-size: var(--account-font-caption);
  font-weight: 600;
}

.account-role-selector {
  min-width: 0;
  margin: 0;
  border: 0;
  padding: 0;
}

.account-role-selector legend {
  margin-bottom: 8px;
}

.account-role-selector > div {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.account-role-selector button {
  display: flex;
  min-width: 0;
  min-height: 72px;
  align-items: flex-start;
  flex-direction: column;
  gap: 7px;
  border: 1px solid var(--account-border);
  border-radius: 10px;
  background: #ffffff;
  padding: 10px;
  color: var(--account-body);
  cursor: pointer;
  text-align: left;
}

.account-role-selector button strong {
  font-size: var(--account-font-secondary);
  line-height: 17px;
  font-weight: 600;
}

.account-role-selector button:hover,
.account-role-selector button.is-selected {
  border-color: #9db9af;
  background: var(--account-primary-soft);
}

.account-role-selector button.is-selected {
  box-shadow: inset 0 0 0 1px #9db9af;
}

.account-create-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid var(--account-border);
  margin: 0 -22px -22px;
  padding: 14px 22px;
  background: #fafbf8;
}

.account-button {
  min-width: 92px;
  padding: 0 14px;
}

.account-button--primary {
  background: var(--account-primary);
  color: #ffffff;
}

.account-button--secondary {
  border-color: var(--account-border-strong);
  background: #ffffff;
  color: var(--account-body);
}

.account-button--secondary:hover:not(:disabled) {
  background: var(--account-surface-soft);
}

.account-page button:disabled,
.account-page input:disabled,
.account-page select:disabled {
  cursor: not-allowed;
  opacity: 0.62;
}

.account-page button:focus-visible,
.account-page input:focus,
.account-page select:focus {
  outline: none;
  box-shadow: 0 0 0 3px var(--account-focus);
}

.account-page input:focus,
.account-page select:focus {
  border-color: #729b8e;
}

@keyframes account-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1100px) {
  .account-workspace {
    grid-template-columns: 1fr;
  }
  .role-guide {
    position: static;
  }
  .role-guide-list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .role-guide-list article + article {
    border-top: 0;
    border-left: 1px solid #e9eae5;
  }
}
@media (max-width: 860px) {
  .account-shell {
    padding-right: 18px;
    padding-left: 18px;
  }
  .account-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 9px;
  }
  .role-filters {
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .account-search {
    width: 100%;
  }
  .account-table-head {
    display: none;
  }
  .account-row {
    grid-template-columns: minmax(220px, 1fr) 150px 120px;
    grid-template-areas: "person role actions" "person scope joined";
    gap: 5px 12px;
  }
  .account-person {
    grid-area: person;
  }
  .account-role-display {
    grid-area: role;
  }
  .account-scope {
    grid-area: scope;
  }
  .account-joined {
    grid-area: joined;
  }
  .account-row-actions {
    grid-area: actions;
  }
}
@media (max-width: 640px) {
  .account-shell {
    padding: 18px 12px 32px;
  }
  .account-page-header {
    min-height: 0;
    align-items: stretch;
    flex-direction: column;
    gap: 13px;
  }
  .account-page-heading h1 {
    font-size: 24px;
    line-height: 32px;
  }
  .account-create-button {
    width: 100%;
  }
  .recovery-row {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;
  }
  .recovery-actions .account-button {
    flex: 1 1 0;
  }
  .role-filters button {
    min-height: 40px;
  }
  .account-list-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }
  .account-row {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: "person person" "role actions" "scope joined";
    min-height: 0;
    gap: 9px 12px;
    padding: 13px;
  }
  .account-scope {
    align-self: center;
  }
  .account-joined {
    align-self: center;
    text-align: right;
  }
  .role-guide-list {
    grid-template-columns: 1fr;
  }
  .role-guide-list article + article {
    border-top: 1px solid #e9eae5;
    border-left: 0;
  }
  .account-modal-backdrop {
    align-items: end;
    padding: 0;
  }
  .account-create-modal {
    width: 100%;
    max-height: calc(100vh - 24px);
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 16px 16px 0 0;
  }
  .account-create-fields,
  .account-role-selector > div {
    grid-template-columns: 1fr;
  }
  .account-field--wide {
    grid-column: auto;
  }
  .account-role-selector button {
    min-height: 58px;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
}
@media (prefers-reduced-motion: reduce) {
  .account-page *,
  .account-page *::before,
  .account-page *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}`],
})
export class PageMembersComponent implements OnInit {
    public loading = false;
    public creating = false;
    public removingMemberId = '';
    public recoveryBusyId = '';
    public error = '';
    public notice = '';

    public members: any[] = [];
    public recoveryRequests: any[] = [];
    public counts: any = { all: 0, doctor: 0, operator: 0, admin: 0 };
    public search: any = { text: '', role: '' };

    public readonly roles: string[] = ['doctor', 'operator', 'admin'];
    public readonly roleDefinitions: any[] = [
        {
            key: 'doctor',
            label: '한의사',
            summary: '진료와 차트 작성',
            scope: '진료실 · 예진 확인 · SOAP 차트 · 임상 AI · 최종 저장',
        },
        {
            key: 'operator',
            label: '원무/운영',
            summary: '접수와 환자 운영',
            scope: '환자·방문 등록 · 접수 · 예진 · 진료 대기 · 수납',
        },
        {
            key: 'admin',
            label: '관리자',
            summary: '계정과 운영 환경 관리',
            scope: '계정·권한 관리 · 일정·자원 관리 · 전체 업무 현황 조회',
        },
    ];

    public showCreateModal = false;
    public passwordVisible = false;
    public createData: any = {
        name: '',
        email: '',
        password: '',
        role: 'operator',
    };
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
        if (!this.service.auth.allow.role('admin', '/hanscribe/encounters')) return;
        await this.load();
    }

    public get busy() {
        return this.loading || this.creating || !!this.removingMemberId || !!this.recoveryBusyId;
    }

    public get currentUserId() {
        return String(this.service.auth.session?.id || '');
    }

    public get hasSearch() {
        return !!String(this.search.text || '').trim();
    }

    public get resultLabel() {
        if (this.search.role) return `${this.roleLabel(this.search.role)} ${this.members.length}명`;
        if (this.hasSearch) return `검색 결과 ${this.members.length}명`;
        return `전체 ${this.counts.all || 0}명`;
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const [accountResponse, recoveryResponse] = await Promise.all([
                wiz.call('list', this.search),
                wiz.call('list_recovery_requests', {}),
            ]);

            if (accountResponse.code === 200) {
                const payload = accountResponse.data || {};
                this.members = Array.isArray(payload) ? payload : (payload.items || []);
                this.counts = Array.isArray(payload) ? this.counts : (payload.counts || this.counts);
            } else {
                this.error = this.responseMessage(accountResponse.data, '계정 목록을 불러오지 못했습니다.');
            }

            if (recoveryResponse.code === 200) {
                this.recoveryRequests = recoveryResponse.data || [];
            }
        } catch (e) {
            this.error = '계정 정보를 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public async applySearch() {
        await this.load();
    }

    public async clearSearch() {
        this.search.text = '';
        await this.load();
    }

    public async filterByRole(role: string) {
        if (this.search.role === role) return;
        this.search.role = role;
        await this.load();
    }

    public accountCount(role: string) {
        if (!role) return Number(this.counts.all || 0);
        return Number(this.counts[role] || 0);
    }

    public memberInitial(member: any) {
        const name = String(member?.name || member?.email || '?').trim();
        return name.charAt(0).toUpperCase() || '?';
    }

    public memberScope(role: string) {
        return this.roleDefinition(role).summary;
    }

    public roleScope(role: string) {
        return this.roleDefinition(role).scope;
    }

    public roleLabel(role: string) {
        return hanscribeRoleLabel(role);
    }

    public roleTextClass(role: string) {
        const safeRole = this.roles.includes(role) ? role : 'unknown';
        return `account-role-text account-role-text--${safeRole}`;
    }

    public isCurrentMember(member: any) {
        return !!member && String(member.id || '') === this.currentUserId;
    }

    public memberRemovalDisabled(member: any) {
        return this.busy || this.isCurrentMember(member);
    }

    public async openCreateAccount() {
        this.createData = { name: '', email: '', password: '', role: 'operator' };
        this.passwordVisible = false;
        this.showCreateModal = true;
        this.error = '';
        await this.service.render();
        setTimeout(() => document.getElementById('account-create-name')?.focus(), 0);
    }

    public async closeCreateAccount() {
        if (this.creating) return;
        this.showCreateModal = false;
        await this.service.render();
    }

    public async selectCreateRole(role: string) {
        if (!this.roles.includes(role) || this.creating) return;
        this.createData.role = role;
        await this.service.render();
    }

    public async togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
        await this.service.render();
    }

    public async createAccount() {
        if (this.creating) return;
        const name = String(this.createData.name || '').trim();
        const email = String(this.createData.email || '').trim();
        const password = String(this.createData.password || '');
        if (!name) {
            await this.service.modal.error('이름을 입력해주세요.');
            return;
        }
        if (!email) {
            await this.service.modal.error('이메일을 입력해주세요.');
            return;
        }
        if (password.length < 8) {
            await this.service.modal.error('초기 비밀번호를 8자 이상 입력해주세요.');
            return;
        }

        this.creating = true;
        await this.service.render();
        const response = await wiz.call('invite', this.createData);
        this.creating = false;
        if (response.code === 200) {
            const accountName = name;
            this.showCreateModal = false;
            this.notice = `${accountName} 계정을 추가했습니다.`;
            await this.load();
            return;
        }
        await this.service.modal.error(this.responseMessage(response.data, '계정을 추가하지 못했습니다.'));
        await this.service.render();
    }

    public async removeMember(member: any) {
        if (!member || this.memberRemovalDisabled(member)) return;
        const confirmed = await this.service.modal.show({
            title: '계정 삭제',
            message: `${member.name || member.email} 계정을 삭제할까요? 이 계정은 더 이상 로그인할 수 없습니다.`,
            action: '계정 삭제',
            actionBtn: 'error',
            status: 'error',
        });
        if (!confirmed) return;

        this.removingMemberId = member.id;
        this.error = '';
        this.notice = '';
        await this.service.render();
        const response = await wiz.call('remove', { id: member.id });
        this.removingMemberId = '';
        if (response.code === 200) {
            this.notice = `${member.name || member.email} 계정을 삭제했습니다.`;
            await this.load();
            return;
        }
        this.error = this.responseMessage(response.data, '계정을 삭제하지 못했습니다.');
        await this.service.render();
    }

    public async resolveRecoveryRequest(item: any, action: string) {
        if (!item || this.recoveryBusyId) return;
        const approve = action === 'approve';
        const confirmed = await this.service.modal.show({
            title: approve ? '비밀번호 재설정 승인' : '비밀번호 재설정 거절',
            message: approve
                ? `${item.name || item.email}님의 본인 확인을 완료했습니까?`
                : `${item.name || item.email}님의 요청을 거절하시겠습니까?`,
            action: approve ? '승인' : '거절',
            actionBtn: approve ? 'success' : 'error',
            status: approve ? 'success' : 'error',
        });
        if (!confirmed) return;

        this.recoveryBusyId = item.id;
        await this.service.render();
        const response = await wiz.call('resolve_recovery_request', { id: item.id, action });
        this.recoveryBusyId = '';
        if (response.code === 200) {
            this.notice = approve ? '비밀번호 재설정을 승인했습니다.' : '비밀번호 재설정 요청을 거절했습니다.';
            await this.load();
            return;
        }
        this.error = this.responseMessage(response.data, '요청을 처리하지 못했습니다.');
        await this.service.render();
    }

    private roleDefinition(role: string) {
        return this.roleDefinitions.find((item) => item.key === role) || {
            key: role,
            label: this.roleLabel(role),
            summary: '권한 확인 필요',
            scope: '관리자에게 업무 범위를 확인해주세요.',
        };
    }

    private responseMessage(data: any, fallback: string) {
        if (typeof data === 'string' && data.trim()) return data;
        if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
        return fallback;
    }
}

export default PageMembersComponent;